import { EmployeesListItemFiltered } from "../EmployeesListItemFiltered/EmployeesListItemFiltered";

export const EmployeesListFiltered = ({ employees }) => {
    return (
        !employees.length ? <div className="employees-list-empty">Нет сотрудников в заявке</div>
            : employees.map((employer) =>
                <EmployeesListItemFiltered employer={employer}  key={employer.agreement.uid} />,
            )
    );
};
